import './Nomination.scss'

interface NominationProps {
	lang: String
}

const Nomination: React.FC<NominationProps> = (props: NominationProps) => {
	return (<div className="nomination">
			{props.lang==='nl'
			? <><h1>Nominatie: Studente van het jaar</h1>
				<p>Tijdens Women at the Top vindt de uitreiking plaats van de Studente van het Jaar in verschillende categorieën. Hiermee willen we elkaar inspireren en laten zien wat studentes van jouw leeftijd al bereikt hebben op uiteenlopende gebieden. Denk bijvoorbeeld aan sport, maatschappelijke betrokkenheid, innovatie, educatie, duurzaamheid, en meer.</p>
				<p>Ken jij een vriendin, kennis of medestudent die je graag in het zonnetje wilt zetten? De nominatie is nog niet geopend, maar houdt de ogen open voor updates!</p>
				<p>Voor de Studentes van het Jaar zijn er leuke prijzen te winnen. Doe mee en vier succes samen met ons!</p></>
			: <><h1>Nomination: Student of the year</h1>
				<p>During Women at the Top, the Student of the Year awards will be presented across various categories. Our goal is to inspire each other and showcase what students your age have already achieved in different fields. Think of areas such as sports, social engagement, innovation, education, sustainability, and more.</p>
				<p>Do you know a friend, acquaintance, or fellow student whom you would like to put in the spotlight? The nomination is not open yet, but keep an eye out for updates!</p>
				<p>There are fantastic prizes to be won for the Students of the Year. Join us and celebrate success together!</p></>
			}
			{/* <div className="formsContainer">
				<iframe title='Nomination form' src="https://docs.google.com/forms/d/e/1FAIpQLSdKe5Ivf3A394a5gDivxNPJ-6hOib4kQOtNLKGPsX_YYZR9eA/viewform?embedded=true" width="100%" height="100%" frameBorder="0" marginHeight={0} marginWidth={0}>Laden…</iframe>
			</div> */}
		</div>)
}

export default Nomination